import { defaultEmploymentInformation } from '../../../types';
import { saveApplication, debounce } from './../../../utilities';
import { DEBOUNCE_TIME } from './../../../constants';
import { getLeaseholderIDs } from 'utils';
import validate from '../../../validations';

const getOccupantsIndexAndIDs = (occupants) => {
  const occupantIndex = []
  occupants.forEach((person, index) => {
    if (person.status === 'Lease Holder' || person.status === 'leaseholder') occupantIndex.push({index, id: person.id})
  })
  return occupantIndex
}

export default {
  refreshOn: ({ occupants }) => [occupants],
  init: (_, stateManager) => {
    debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)

    const { employmentInformations, occupants } = stateManager.store.getState()
    const indexAndIDs = getOccupantsIndexAndIDs(occupants)

    const updatedEmploymentInfoList = indexAndIDs.map((p) => {
      const employee = employmentInformations.find((item) => item.occupant_index === p.index+1 || item?.person_id == p.id)
      if(employee) return employee
      return { ...defaultEmploymentInformation, id: p.id, occupant_index: p.index+1 }

    })

    stateManager.setEmploymentInformations([ ...updatedEmploymentInfoList ])
    validate(3000)
},
  'EmploymentInformation.Wrapper.employmentInfoList': ({ employmentInformations }, stateManager) => {
    debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)
    stateManager.setEmploymentInformations(employmentInformations)
    validate(3000)
  },

};